import React from "react";

const FormulaBar = ({
  value,
  onChange,
  selectedCell,
  selectedRange,
}: {
  value: string;
  onChange: (v: string) => void;
  selectedCell: { row: number; col: number };
  selectedRange?: { start: { row: number; col: number }; end: { row: number; col: number } } | null;
}) => {
  const getCellReference = () => {
    if (selectedRange) {
      const start = `${String.fromCharCode(65 + selectedRange.start.col)}${selectedRange.start.row + 1}`;
      const end = `${String.fromCharCode(65 + selectedRange.end.col)}${selectedRange.end.row + 1}`;
      return start === end ? start : `${start}:${end}`;
    }
    return `${String.fromCharCode(65 + selectedCell.col)}${selectedCell.row + 1}`;
  };

  return (
    <div className="flex items-center p-2 border-b border-gray-300 bg-white shadow-sm">
      <div className="flex items-center space-x-4">
        {/* Function button */}
        <button className="p-1 hover:bg-gray-100 rounded" title="Insert Function">
          <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        </button>
        
        {/* Cell reference */}
        <div className="flex items-center space-x-2">
          <span className="text-sm font-medium text-gray-700 min-w-[60px]">
            {getCellReference()}
          </span>
        </div>
      </div>
      
      {/* Formula input */}
      <div className="flex-1 ml-4">
        <input
          className="w-full border-none outline-none bg-transparent text-sm font-mono px-2 py-1 focus:bg-gray-50 rounded formula-bar-input"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Enter a value or formula"
        />
      </div>
      
      {/* Formula suggestions */}
      <div className="flex items-center space-x-2 ml-4">
        <button className="text-xs text-gray-500 hover:text-gray-700 px-2 py-1 rounded hover:bg-gray-100">
          SUM
        </button>
        <button className="text-xs text-gray-500 hover:text-gray-700 px-2 py-1 rounded hover:bg-gray-100">
          AVERAGE
        </button>
        <button className="text-xs text-gray-500 hover:text-gray-700 px-2 py-1 rounded hover:bg-gray-100">
          COUNT
        </button>
        <button className="text-xs text-gray-500 hover:text-gray-700 px-2 py-1 rounded hover:bg-gray-100">
          MAX
        </button>
        <button className="text-xs text-gray-500 hover:text-gray-700 px-2 py-1 rounded hover:bg-gray-100">
          MIN
        </button>
      </div>
    </div>
  );
};

export default FormulaBar; 